module.exports = __webpack_public_path__ + "static/media/home-site-header@2x.715a7587.jpg";